import React, { useEffect, useState } from "react";
import { Button, Input, Form, notification, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import GenericTable from "../components/GenericTable";
import GenericModal from "../components/GenericModal";
import Spinner from "../components/Loader";
import NavBar from "../components/NavBar";
import { ToolOutlined, FileTextOutlined, ToolFilled } from '@ant-design/icons';
import {
  fetchConfigurablesRequest,
  updateConfigurableRequest,
} from "../redux-saga/actions/configActions";

const { Option } = Select;

const Configurables = () => {
  const dispatch = useDispatch();
  const configurableData = useSelector((state) => state.config.data || []);
  const loading = useSelector((state) => state.config.loading);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [updateInput, setUpdateInput] = useState([]);
  const [editingConfigurable, setEditingConfigurable] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(fetchConfigurablesRequest());
  }, [dispatch]);

  const handleCreateOrEdit = (values) => {
    if (editingConfigurable) {
      const updatedConfigurable = { ...editingConfigurable, ...values };
      dispatch(
        updateConfigurableRequest(
          updatedConfigurable.key,
          updatedConfigurable.value
        )
      );
      setEditingConfigurable(null);
    }

    notification.success({
      message: "Saved",
      description: "The configurable details have been saved successfully.",
    });
    setIsModalVisible(false);
  };

  const handleEdit = (record) => {
    setUpdateInput([
      {
        label: record.key,
        name: "value",
        type: "textarea",
        required: true,
        placeholder: "Enter value",
      },
    ]);
    setEditingConfigurable(record);
    setIsModalVisible(true);
  };

  const filteredData = configurableData.filter((config) =>
    config.key.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  const columnsConfig = [
    { title: "Key", dataIndex: "key", width: 150, sortable: true },
    {
      title: "Value", dataIndex: "value", width: 150, render: (text) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {text}
        </div>
      ), sortable: true
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: 150,
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>Edit</Button>
      ),
    },
  ];

  const modalInputs = [
    {
      label: "Key",
      name: "key",
      type: "text",
      required: true,
      placeholder: "Enter key",
    },
    {
      label: "Value",
      name: "value",
      type: "text",
      required: true,
      placeholder: "Enter value",
    },
  ];

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <div style={{ width: "210px", position: "fixed", height: "100vh", overflowY: "auto", backgroundColor: "#fff", }}>
        <NavBar />
      </div>
      <div style={{ marginLeft: "210px", width: "calc(100% - 230px)", height: "100vh", overflowY: "auto", padding: "20px", boxSizing: "border-box", }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
            <ToolFilled style={{ fontSize: "24px", color: "black" }} />
            <h2 style={{ margin: 0 }}>Configurables</h2>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "40px" }}>
            <span>Records per page:</span>
            <Select value={pageSize} onChange={handlePageSizeChange} style={{ width: 80 }}>
              {[5, 10, 20, 50].map((size) => (
                <Option key={size} value={size}>{size}</Option>
              ))}
            </Select>
          </div>
        </div>

        <div style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}>
          {loading ? (
            <Spinner />
          ) : (
            <GenericTable
              data={filteredData}
              columnsConfig={columnsConfig}
              searchKeys={["key"]}
              pageSize={pageSize}
            />
          )}
        </div>

        {isModalVisible && (
          <GenericModal
            isVisible={isModalVisible}
            handleCancel={() => setIsModalVisible(false)}
            title={
              <span>
                <ToolOutlined style={{ color: "white", marginRight: "8px" }} />
                Edit Configurables
              </span>
            }
            inputs={editingConfigurable ? updateInput : modalInputs}
            onSubmit={handleCreateOrEdit}
            predefinedData={editingConfigurable || {}}
          />
        )}
      </div>
    </div>
  );
};

export default Configurables;
